import { Box } from '@mui/material'

interface ICenteredBoxProps {
    children?: React.ReactNode
}

const LeftBox = ({ children }: ICenteredBoxProps) => {
    return (<Box
        display="flex"
        justifyContent="flex-start"
        alignItems="flex-start"
        height={'100%'}
    >
        {children}
    </Box>
    )
}

export default LeftBox